import { create } from 'zustand';
import type { MeDto } from '@fas/types';

/** `offline`: a session exists but the server could not be reached to restore it (§57 resilience). */
export type AuthStatus = 'loading' | 'authenticated' | 'anonymous' | 'offline';

interface AuthState {
  status: AuthStatus;
  /** Short-lived access token, kept in memory only (never localStorage — XSS mitigation, §50). */
  accessToken: string | null;
  me: MeDto | null;
  setAccessToken: (token: string) => void;
  setSession: (token: string, me: MeDto) => void;
  setMe: (me: MeDto) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'loading',
  accessToken: null,
  me: null,
  setAccessToken: (accessToken) => set({ accessToken }),
  setSession: (accessToken, me) => set({ accessToken, me, status: 'authenticated' }),
  setMe: (me) => set({ me }),
  clear: () => set({ accessToken: null, me: null, status: 'anonymous' }),
}));
